import { Component } from '@angular/core';
import { NavbarComponent } from "../../../../partials/navbar/navbar.component";
import { FooterComponent } from "../../../../partials/footer/footer.component";
import { LanguageService } from '../../../../services/language.service';

@Component({
  selector: 'app-what-should-your-tire-pressure-be-in-summer',
  standalone: true,
  imports: [NavbarComponent, FooterComponent],
  templateUrl: './what-should-your-tire-pressure-be-in-summer.component.html',
  styleUrl: './what-should-your-tire-pressure-be-in-summer.component.css'
})
export class WhatShouldYourTirePressureBeInSummerComponent {
  texts:any;
  back: any;

  constructor(private langServ: LanguageService) {
    this.texts = this.langServ.getWebisteTexts().posts.tire_presure;
    this.back = this.langServ.getWebisteTexts().posts.volver_text;
  }
}
